import React from "react";
import i18n from "../../../i18n/i18n";
import Loader from "../../../common/components/shared/loader/loader";
import {Api} from "../../../helpers/api";
import {HttpError} from "../../../common/components/shared/httpError/httpError";
import {AlertModel} from "../../models/alert";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../common/models/httpError";
import AlertTile from "./alertTile/alertTile";
import {AlertsService} from "../../services/alertsService";
import ReloadButton from "../../../common/components/shared/reloadButton/reloadButton";
import "./alertList.scss";
import {storesContext} from "../../../common/stores/stores";
import {IUserStore} from "../../../administration/stores/userStore";
import Pagination from "../../../common/components/shared/pagination/pagination";
import {IPaginationStore} from "../../../common/stores/paginationStore";
import {Utils} from "../../../helpers/utils";

interface AlertListState {
    alertsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
    alerts: AlertModel[] | undefined;
    currentPage: number;
}

export default class AlertList extends React.Component <any, AlertListState> {
    static contextType = storesContext;

    constructor(props: any) {
        super(props);

        this.state = {
            alertsResponse: undefined,
            alerts: undefined,
            currentPage: 0
        };
    }

    private get alerts() {
        return this.state.alerts;
    }

    public async componentDidMount() {
        await this.getCountOfUnreadAlerts();
        await this.getAllAlerts();
    }

    public render(): JSX.Element {
        return (
            <div className="alert-list">
                {this.renderContent()}
            </div>
        );
    }

    private renderContent(): JSX.Element {
        if (!Api.isSuccess(this.state.alertsResponse)) {
            return (
                <HttpError
                    response={this.state.alertsResponse}
                    cause={i18n.t("alerts.retrievalErrorSuffix")}
                />
            );
        } else if (this.alerts) {
            return (
                <>
                    {this.renderHeader()}
                    <div className="alerts-content">
                        {this.renderAlertList()}
                    </div>
                    <Pagination
                        currentPage={this.state.currentPage}
                        onPageChange={async () => {
                            await this.getAllAlerts();
                            Utils.scrollToFirstClass("alert-tile");
                        }}
                    />
                </>
            );
        } else {
            return (
                <Loader/>
            );
        }
    }

    private renderAlertList(): JSX.Element[] {
        const paginationStore = this.context.paginationStore as IPaginationStore;

        const alertList: JSX.Element[] = [];

        this.alerts!.map((alert) => {
            alertList.push(<AlertTile
                data={alert}
                key={alert.id}
                reload={async () => {
                    const response = await AlertsService.getAll({
                        offset: paginationStore.offset,
                        size: paginationStore.size
                    });
                    this.setState({alerts: response?.data?.data || null, alertsResponse: response});
                }}
            />);
        });

        return alertList;
    }

    private renderHeader() {
        return (
            <div className="header">
                <div className="actions">
                    <ReloadButton
                        reloadFunc={this.reload.bind(this)}
                        testId="alert-list-reload-btn"
                    />
                </div>
            </div>
        );
    }

    private async getAllAlerts() {
        const paginationStore = this.context.paginationStore as IPaginationStore;
        this.setState({alertsResponse: undefined});

        const response = await AlertsService.getAll({
            offset: paginationStore.offset,
            size: paginationStore.size
        });

        this.setState({
            alerts: response?.data?.data || null,
            alertsResponse: response,
            currentPage: response?.data?.currentPage || 0
        });

        paginationStore.setNumberOfElements(response?.data?.numberOfElements || 0);
        paginationStore.setNumberOfPages(response?.data?.numberOfPages || 0);
    }

    private async reload() {
        this.setState({alerts: undefined});

        await this.getAllAlerts();
    }

    private async getCountOfUnreadAlerts() {
        const userStore = this.context.userStore as IUserStore;

        const responseCountOfAlerts = await AlertsService.getCountOfUnreadAlerts();
        userStore.setUnreadAlertsCount(responseCountOfAlerts?.data?.count);
    }
}

